// Emphasises the label in "Label: value" lines in the product description.
//
// These listings are written as structured data in prose form — every paragraph is
// "Rims: 48mm deep carbon rims...", "Cosmetic Condition: No cracks...". Rendered as
// identical full-width paragraphs there is nothing for the eye to catch, so the whole
// block reads as a wall of text. Emphasising the label gives a scannable left edge
// without removing or reordering a single word the shop wrote.
//
// Deliberately conservative: it only ever wraps text that already looks like a label,
// and any paragraph it is unsure about is left exactly as authored.

(() => {
  // Longer than this is a sentence containing a colon, not a label.
  const MAX_LABEL_LENGTH = 40;

  const labelise = (paragraph) => {
    if (paragraph.dataset.labelled) return;
    paragraph.dataset.labelled = 'true';

    // The first text node is where a label would be. Walking to it (rather than reading
    // innerHTML) keeps any markup the shop authored inside the paragraph intact.
    const walker = document.createTreeWalker(paragraph, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();
    while (node && !node.nodeValue.trim()) node = walker.nextNode();
    if (!node) return;

    const text = node.nodeValue;
    const colonIndex = text.indexOf(':');
    if (colonIndex < 1 || colonIndex > MAX_LABEL_LENGTH) return;

    // A colon with no value after it, here or in a following node, is not a label.
    if (!text.slice(colonIndex + 1).trim() && !paragraph.textContent.slice(colonIndex + 1).trim()) return;

    const label = document.createElement('strong');
    label.className = 'product__description-label';
    label.textContent = text.slice(0, colonIndex + 1);

    const remainder = document.createTextNode(text.slice(colonIndex + 1));
    node.parentNode.replaceChild(remainder, node);
    remainder.parentNode.insertBefore(label, remainder);
  };

  const run = () => {
    document.querySelectorAll('.product_description .accordion__content > p').forEach(labelise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
